define((require) => {
    "use strict";

    const {DateUtil}   = require("shared/util/DateUtil");
    const Marionette = require("marionette");
    const template   = require("editor/ui/common/DefaultFooterView.tpl");

    /**
     * The footer.
     *
     * @class DefaultFooterView
     * @constructor
     */
    return Marionette.Layout.extend({
        template,

        templateHelpers() {
            return {
                currentYear: DateUtil.currentYear()
            };
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/common/DefaultFooterView.js